class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.handleScroll, { passive: true });

    this.onScroll();
  }

  handleScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.onScroll();
      this.ticking = false;
    });
  }

  onScroll() {
    if (window.scrollY > window.innerHeight) {
      this.removeAttribute('data-hidden');
    } else {
      this.setAttribute('data-hidden', true);
    }
  }
}

customElements.define('back-to-top', BackToTop);
